import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker (production only — CRA dev re-builds break it)
// NOTE: we deliberately do NOT call skipWaiting from here. The
// `AppUpdateBanner` component owns that decision so the user sees a tappable
// "New version available — refresh" pill instead of having the page yanked
// out from under them mid-workout-set.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
